<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    legend: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.renderChart(this.chartdata, {
      responsive: true,
      title: {
        display: true,
        text: this.title,
      },
      layout: {
        padding: {
          bottom: 25, //set that fits the best
          // left: 100,
        },
      },
      // maintainAspectRatio: false,
      legend: {
        display: this.legend,
        position: "bottom",
        fullSize: false,
      },
      tooltips: {
        xAlign: "center",
        position: "nearest",
        
      },
    });
  },
  watch: {
    chartdata() {
      this.$data._chart.update();
    },
  },
};
</script>
